// Core
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import validator from 'validator';
import { Alert, Modal } from 'antd';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import InputField from 'components/commonComponents/InputField';
import Button from 'components/commonComponents/Button';
import { APP_ID } from 'config/constants';

const RedeemWallet = (props) => {
  const { onClose, open, language, onRedeemed } = props;
  const { t } = useTranslation();
  const [dataSet, setData] = useState({});
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { name, email, phone } = dataSet;
  const [errorAlert, setErrorAlert] = useState({ msg: '', key: Math.random(), open: false, severity: '' });

  const handleOnChange = (key) => (_value) => {
    setError({
      ...error,
      [key]: null
    });
    setData({
      ...dataSet,
      [key]: _value
    });
  };

  const handleSave = async () => {
    const errors = {
      name: !name && 'Enter the name',
      email: (!email && 'Enter valid email') || (!validator.isEmail(email) && 'Enter valid email'),
      phone: (!phone && 'Enter valid phone') || (!validator.isNumeric(phone) && 'Enter valid phone'),
    };

    setError(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('action', 'redeem');
    formData.append('appId', APP_ID);
    formData.append('fullname', name);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('language', language);
    const res = await fetchData(restAPIs.walletRedeem(formData));
    if (res.statusCode === 200) {
      setData({});
      setError({});
      onRedeemed(res.errormessage || t('redeem_success'));
      onClose();
    } else {
      setErrorAlert({ msg: res.errormessage, key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }
    setIsLoading(false);
  };

  const handleClose = (event, reason) => {
    setData({});
    setError({});
    setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });

    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className='__common_model_class'
      keyboard={false}
      maskClosable={false}
      footer={null}
      closable={false}
    >
      <div className='__common_model_content'>
        <h3 className='____common_model_class_head'>{t('redeem')}</h3>
        <div style={{ marginBottom: '20px', width: '100%' }}>
          <InputField
            onChange={handleOnChange('name')}
            value={name}
            placeholder={t('name')}
            type='text'
            error={error.name}
          />
        </div>
        <div style={{ marginBottom: '20px', width: '100%' }}>
          <InputField
            onChange={handleOnChange('email')}
            value={email}
            placeholder={t('email')}
            type='email'
            error={error.email}
          />
        </div>
        <div style={{ marginBottom: '20px', width: '100%' }}>
          <InputField
            onChange={handleOnChange('phone')}
            value={phone}
            placeholder={t('phone')}
            type='number'
            error={error.phone}
          />
        </div>
        <div className='d-flex align-items-center justify-content-end' style={{ marginTop: '15px', gridGap: '10px' }}>
          <a onClick={() => handleClose(null, null)} style={{ cursor: 'pointer', margin: '0 10px' }}>{t('cancel')}</a>
          <Button
            withLoader
            loading={isLoading}
            disabled={isLoading}
            handleOnClick={handleSave}
            label={t('submit')}
          />
        </div>
        {errorAlert && errorAlert.open &&
          <Alert
            type='error'
            message={errorAlert.msg}
            showIcon
            style={{ width: '100%', marginTop: '15px' }}
          />
        }
      </div>
    </Modal>
  );
};

export default RedeemWallet;

RedeemWallet.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  language: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRedeemed: PropTypes.func,
};
